var _g, _g2, _path, _path2, _path3, _g3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiOfferBgExpire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 228,
    viewBox: "0 0 372 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_32383_112404)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 360,
    height: 216,
    rx: 12,
    fill: "#F4EEE2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_32383_112404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 209.389C6 214.697 10.303 219 15.6111 219H356.389C361.697 219 366 214.697 366 209.389C366 206.386 364.596 203.555 362.205 201.737L193.262 73.3198C188.97 70.0576 183.03 70.0576 178.738 73.3198L9.79497 201.737C7.40396 203.555 6 206.386 6 209.389Z",
    fill: "#F4EFE4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.5996C6 14.3905 7.79086 12.5996 10 12.5996H362C364.209 12.5996 366 14.3905 366 16.5996V35.3798C366 37.0783 364.927 38.5915 363.325 39.154L187.325 100.935C186.467 101.236 185.533 101.236 184.675 100.935L8.67515 39.154C7.07258 38.5915 6 37.0783 6 35.3798V16.5996Z",
    fill: "#EBE5D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15C6 8.37258 11.3726 3 18 3H354C360.627 3 366 8.37258 366 15V21.6449C366 26.6664 362.874 31.1568 358.164 32.8993L190.164 95.0593C187.477 96.0535 184.523 96.0535 181.836 95.0593L13.8359 32.8993C9.12649 31.1568 6 26.6664 6 21.6449V15Z",
    fill: "#F8F4EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.715 57.3548C157.715 60.6233 156.965 64.5047 156.965 66.0369C156.429 71.6548 153.75 74.2084 152.143 76.2513C150.857 77.8855 150.179 81.3584 150 82.8905C150.536 96.6797 160.715 113.023 173.037 117.619C182.895 121.296 198.931 116.768 205.717 114.044C206.967 113.703 210.86 111.593 216.432 105.873C223.397 98.7226 220.718 82.8905 221.254 80.337C221.789 77.7834 222.861 72.6763 220.718 67.5691C218.575 62.462 214.289 63.4834 207.324 56.3335C200.36 49.1835 194.467 47.6512 191.252 47.1405C188.681 46.732 184.466 47.3108 182.68 47.6512C180.359 48.162 175.18 49.2855 173.037 49.6941C170.358 50.2048 164.465 53.2691 160.715 57.3548Z",
    fill: "#B3BCD2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_32383_112404)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 186.688,
    cy: 83.4548,
    r: 30.1765,
    fill: "#A0A9BE"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.034 82.936C173.439 82.936 173.791 82.8853 174.09 82.784C174.394 82.6827 174.642 82.544 174.834 82.368C175.031 82.1867 175.178 81.9733 175.274 81.728C175.37 81.4827 175.418 81.2133 175.418 80.92C175.418 80.3333 175.223 79.8827 174.834 79.568C174.45 79.2533 173.861 79.096 173.066 79.096H171.69V82.936H173.034ZM178.57 89H176.626C176.258 89 175.991 88.856 175.826 88.568L173.394 84.864C173.303 84.7253 173.202 84.6267 173.09 84.568C172.983 84.5093 172.823 84.48 172.61 84.48H171.69V89H169.538V77.432H173.066C173.85 77.432 174.522 77.5147 175.082 77.68C175.647 77.84 176.109 78.0667 176.466 78.36C176.829 78.6533 177.095 79.0053 177.266 79.416C177.437 79.8213 177.522 80.2693 177.522 80.76C177.522 81.1493 177.463 81.5173 177.346 81.864C177.234 82.2107 177.069 82.5253 176.85 82.808C176.637 83.0907 176.37 83.3387 176.05 83.552C175.735 83.7653 175.375 83.9333 174.97 84.056C175.109 84.136 175.237 84.232 175.354 84.344C175.471 84.4507 175.578 84.5787 175.674 84.728L178.57 89ZM184.264 83.952C184.264 83.696 184.227 83.456 184.152 83.232C184.083 83.0027 183.976 82.8027 183.832 82.632C183.688 82.4613 183.504 82.328 183.28 82.232C183.061 82.1307 182.805 82.08 182.512 82.08C181.941 82.08 181.491 82.2427 181.16 82.568C180.835 82.8933 180.627 83.3547 180.536 83.952H184.264ZM180.496 85.144C180.528 85.5653 180.603 85.9307 180.72 86.24C180.837 86.544 180.992 86.7973 181.184 87C181.376 87.1973 181.603 87.3467 181.864 87.448C182.131 87.544 182.424 87.592 182.744 87.592C183.064 87.592 183.339 87.5547 183.568 87.48C183.803 87.4053 184.005 87.3227 184.176 87.232C184.352 87.1413 184.504 87.0587 184.632 86.984C184.765 86.9093 184.893 86.872 185.016 86.872C185.181 86.872 185.304 86.9333 185.384 87.056L185.952 87.776C185.733 88.032 185.488 88.248 185.216 88.424C184.944 88.5947 184.659 88.7333 184.36 88.84C184.067 88.9413 183.765 89.0133 183.456 89.056C183.152 89.0987 182.856 89.12 182.568 89.12C181.997 89.12 181.467 89.0267 180.976 88.84C180.485 88.648 180.059 88.368 179.696 88C179.333 87.6267 179.048 87.168 178.84 86.624C178.632 86.0747 178.528 85.44 178.528 84.72C178.528 84.16 178.619 83.6347 178.8 83.144C178.981 82.648 179.24 82.2187 179.576 81.856C179.917 81.488 180.331 81.1973 180.816 80.984C181.307 80.7707 181.859 80.664 182.472 80.664C182.989 80.664 183.467 80.7467 183.904 80.912C184.341 81.0773 184.717 81.32 185.032 81.64C185.347 81.9547 185.592 82.344 185.768 82.808C185.949 83.2667 186.04 83.792 186.04 84.384C186.04 84.6827 186.008 84.8853 185.944 84.992C185.88 85.0933 185.757 85.144 185.576 85.144H180.496ZM191.859 85.496C191.288 85.5227 190.808 85.5733 190.419 85.648C190.03 85.7173 189.718 85.808 189.483 85.92C189.248 86.032 189.08 86.1627 188.979 86.312C188.878 86.4613 188.827 86.624 188.827 86.8C188.827 87.1467 188.928 87.3947 189.131 87.544C189.339 87.6933 189.608 87.768 189.939 87.768C190.344 87.768 190.694 87.696 190.987 87.552C191.286 87.4027 191.576 87.1787 191.859 86.88V85.496ZM187.331 81.936C188.275 81.072 189.411 80.64 190.739 80.64C191.219 80.64 191.648 80.72 192.027 80.88C192.406 81.0347 192.726 81.2533 192.987 81.536C193.248 81.8133 193.446 82.1467 193.579 82.536C193.718 82.9253 193.787 83.352 193.787 83.816V89H192.891C192.704 89 192.56 88.9733 192.459 88.92C192.358 88.8613 192.278 88.7467 192.219 88.576L192.043 87.984C191.835 88.1707 191.632 88.336 191.435 88.48C191.238 88.6187 191.032 88.736 190.819 88.832C190.606 88.928 190.376 89 190.131 89.048C189.891 89.1013 189.624 89.128 189.331 89.128C188.984 89.128 188.664 89.0827 188.371 88.992C188.078 88.896 187.824 88.7547 187.611 88.568C187.398 88.3813 187.232 88.1493 187.115 87.872C186.998 87.5947 186.939 87.272 186.939 86.904C186.939 86.696 186.974 86.4907 187.043 86.288C187.112 86.08 187.224 85.8827 187.379 85.696C187.539 85.5093 187.744 85.3333 187.995 85.168C188.246 85.0027 188.552 84.8587 188.915 84.736C189.283 84.6133 189.71 84.5147 190.195 84.44C190.68 84.36 191.235 84.312 191.859 84.296V83.816C191.859 83.2667 191.742 82.8613 191.507 82.6C191.272 82.3333 190.934 82.2 190.491 82.2C190.171 82.2 189.904 82.2373 189.691 82.312C189.483 82.3867 189.299 82.472 189.139 82.568C188.979 82.6587 188.832 82.7413 188.699 82.816C188.571 82.8907 188.427 82.928 188.267 82.928C188.128 82.928 188.011 82.8933 187.915 82.824C187.819 82.7493 187.742 82.664 187.683 82.568L187.331 81.936ZM200.8 82.888C200.576 82.616 200.331 82.424 200.064 82.312C199.803 82.2 199.52 82.144 199.216 82.144C198.917 82.144 198.648 82.2 198.408 82.312C198.168 82.424 197.963 82.5947 197.792 82.824C197.621 83.048 197.491 83.336 197.4 83.688C197.309 84.0347 197.264 84.4453 197.264 84.92C197.264 85.4 197.301 85.808 197.376 86.144C197.456 86.4747 197.568 86.7467 197.712 86.96C197.856 87.168 198.032 87.32 198.24 87.416C198.448 87.5067 198.68 87.552 198.936 87.552C199.347 87.552 199.696 87.4667 199.984 87.296C200.272 87.1253 200.544 86.8827 200.8 86.568V82.888ZM202.776 77.112V89H201.568C201.307 89 201.141 88.88 201.072 88.64L200.904 87.848C200.573 88.2267 200.192 88.5333 199.76 88.768C199.333 89.0027 198.835 89.12 198.264 89.12C197.816 89.12 197.405 89.0267 197.032 88.84C196.659 88.6533 196.336 88.384 196.064 88.032C195.797 87.6747 195.589 87.2347 195.44 86.712C195.296 86.1893 195.224 85.592 195.224 84.92C195.224 84.312 195.307 83.7467 195.472 83.224C195.637 82.7013 195.875 82.248 196.184 81.864C196.493 81.48 196.864 81.1813 197.296 80.968C197.728 80.7493 198.213 80.64 198.752 80.64C199.211 80.64 199.603 80.712 199.928 80.856C200.253 81 200.544 81.1947 200.8 81.44V77.112H202.776Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_32383_112404",
    x: 0,
    y: 0,
    width: 372,
    height: 228,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.583333 0 0 0 0 0.536278 0 0 0 0 0.369444 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32383_112404"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32383_112404",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_32383_112404",
    x: 0,
    y: 63.873,
    width: 372,
    height: 160.127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.766667 0 0 0 0 0.667383 0 0 0 0 0.412083 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32383_112404"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32383_112404",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_32383_112404",
    x: 156.512,
    y: 53.2783,
    width: 60.3516,
    height: 60.353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_32383_112404"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiOfferBgExpire);
export default __webpack_public_path__ + "static/media/hi-offer-bg-expire.b9ecf92bd84edd4f5d91647b1b8a80b7.svg";
export { ForwardRef as ReactComponent };